import { getProgramBaseRoute } from '@/utils/constants/routes'

export const routeBasePath = (_, __, rootState) => {
  const programIdentifier = rootState.route.params.programIdentifier
  return programIdentifier && getProgramBaseRoute(programIdentifier)
}
